
import React, {useEffect} from 'react'
import {useHistory} from "react-router-dom";

import classes from '../../App.module.css'

import '../../assets/css/customstyles.css'
//import '../../assets/css/theme_grey.css'
import '../../assets/css/theme_blue.css'
//import '../../assets/css/theme_green.css'
//import '../../assets/css/theme_red.css'

import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

import {
    Button, 
    InputFieldFF, 
    ReactFinalForm, 
    hasValue,
    CircularLoader,
    CenteredContent
} from '@dhis2/ui';
import {apiServices} from '../../services/apiServices'; 

import swal from 'sweetalert';

import OfflineDb from '../../db'
import {useGlobalSpinnerActionsContext} from '../../context/GlobalSpinnerContext'

const {Form, Field } = ReactFinalForm

export default function Settings () {    
    const [showPasswordFlag, setShowPassword] = React.useState(false)
    const setGlobalSpinner = useGlobalSpinnerActionsContext()


    function onSubmit (values) {
        setGlobalSpinner(true)   
        apiServices.putAPI('31/me/changePassword',values).then(res=>{            
            setGlobalSpinner(false)
            swal({
                title: "Password Changed!",
                text: 'You can now login with your new password',
                icon: "success",
                button: "Close",
            }).then(res=>{
                OfflineDb.deleteDatabse().then(res=>{
                    window.location.reload();
                }).catch(err=>{
                    window.location.reload();
                }) 
            });
            /*OfflineDb.getDataFromPouchDB('loginDetails')
            .then(loginDetails => {
                
                if(loginDetails.data != undefined) {
                    const Authorization= 'Basic '+btoa(loginDetails.data.email+":"+values.newPassword.trim()) 
                    localStorage.setItem('basicAuth', Authorization)
                    swal({
                        title: "Password Changed!",
                        text: 'Your password has been changed successfully.',
                        icon: "success",
                        button: "Close",
                    });
                }
            })*/
            
        }).catch(error => {
            if (error.response) {
                
                swal({
                    title: "Reset password",
                    text: error.response.data.message,
                    icon: "error",
                    button: "Close",
                });
            } else {
                swal({
                    title: "Reset password",
                    text: "",
                    icon: "error",
                    button: "Close",
                });
            }
            setGlobalSpinner(false)
        })
    }


    function showPassword() {
        if(showPasswordFlag) {
            setShowPassword(false)
        } else {
            setShowPassword(true)
        }
    }

    function passwordField() {
        var mediumRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})")
        const required = value => (value ? undefined : 'Please provide a value')
        const scriptCheck = value => (value ? value.match(mediumRegex) != null ? undefined : "Password should contain at least one numeric digit, one uppercase, one lowercase letter and one special character" : undefined )
        const composeValidators = (...validators) => value =>
        validators.reduce((error, validator) => error || validator(value), undefined)

        return (
            <Field
                name='newPassword'
                label='New Password'
                component={InputFieldFF}
                key='newPassword'
                validate={composeValidators(required,scriptCheck)}
                required
                className={showPasswordFlag ? "newpassword" : 'newpassword password'}

            />
        )
    }


    return (

        <div className={classes.container}>
            <main style={{display: 'flex',height: '100%',width: '100%'}}>
                <section className="loginpagemainsection" style={{backgroundColor: '#fff',flexGrow: 1,padding: 20,borderLeft: '1px solid white',}}>
                    <div className="loginformholder">
                        <p className="loginformheading">Reset Password</p>
    
                        <Form 
                            onSubmit={values => onSubmit(values,null,2)}
                            render={({ handleSubmit, form, submitting, pristine, values }) => (
                                <form onSubmit={handleSubmit}>

                                    <Field
                                        name='oldPassword'
                                        label='Old Password'
                                        component={InputFieldFF}
                                        key='oldPassword'
                                        validate= {hasValue}
                                        required
                                        className={'newpassword password'}
                                    />
                                    <div>
                                        {passwordField()}
                                    
                                    {/* <p className="visibilityiconcontainer">
                                    {!showPasswordFlag ? <VisibilityIcon onClick={() => showPassword()} /> :
                                    <VisibilityOffIcon onClick={() => showPassword()} />}
                                    </p> */}
                                    </div>
                                    
                                    <div className="buttons setting-reset">
                                        <Button 
                                            type="submit" 
                                            disabled={submitting}
                                            className="loginbtn"
                                        >
                                            Submit
                                        </Button>
                                            &nbsp;
                                        {/* <Button
                                            type="button"
                                            onClick={form.reset}
                                            disabled={submitting || pristine}
                                        >
                                            Reset
                                        </Button> */}
                                    </div>    
                                </form>
                            )}
                            />
                    </div>
                </section>
            </main>
        </div>            
    )
}


